import type { CreateProjectData } from "./types";

/**
 * The create-project steps, shared by the full-page wizard and the listing
 * page's new-project panel.
 */
export const CREATE_PROJECT_STEPS = [
  "Project Details",
  "Property Boundaries",
  "Location & Size",
  "Data Sources",
  "Tags",
  "Review & Create",
];

export const LOCATION_STEP = 2;
export const LAST_STEP = CREATE_PROJECT_STEPS.length - 1;

export const newCreateProjectData = (preset: Partial<CreateProjectData> = {}): CreateProjectData => ({
  name: "",
  description: "",
  propertyFiles: null,
  selectedPropertySources: [],
  fuelDisruptionFile: null,
  selectedLatLng: null,
  folderId: null,
  projectSize: "small",
  projectAspectRatio: "1:1",
  expansionTiles: [],
  vegetationSource: "",
  fireHistorySource: "",
  selectedAssetSources: [],
  selectedTreatmentSources: [],
  stampRoadsIntoVegetation: true,
  roadSource: "",
  modelUrbanEnvironment: false,
  defaultConstructionTypeId: "",
  ...preset,
});

/** Whether the step's required fields are filled, so Next can be pressed. */
export const canProceedFrom = (step: number, data: CreateProjectData): boolean => {
  switch (step) {
    case 0:
      return data.name.trim() !== "" && data.description.trim() !== "";
    case 1:
      return true; // property boundaries optional
    case 2:
      return data.selectedLatLng !== null;
    case 3:
      return (
        data.vegetationSource !== "" &&
        data.fireHistorySource !== "" &&
        // Urban modelling requires a default construction type (#203)
        (!data.modelUrbanEnvironment || data.defaultConstructionTypeId !== "")
      );
    case 4:
      return true; // Tags step is optional
    default:
      return true;
  }
};
